import React from "react";
import "../Travel/Privacy.css";
export default function Ads() {
  const brand = {
    name: "SIAM TRAVEL",
    address:
      "181 Phạm Ngũ Lão, Quận 1, Thành phố Hồ Chí Minh, 700000, Việt Nam",
    website: "https://www.ruttienthetindung247.online",
    phone: "(+84) 941 297 219",
    email: "raumuongluoc171@gmail.com",
    industry: "tour du lịch",
    updatedAt: "27/12/2025",
  };
  return (
    <section className="customer-reviews d-flex justify-content-center">
      <div className="pp-card">
        <div className="pp-row">
          <span className="pp-label">Đơn vị:</span>
          <span className="pp-value">{brand.name}</span>
        </div>
        <div className="pp-row">
          <span className="pp-label">Địa chỉ:</span>
          <span className="pp-value">{brand.address}</span>
        </div>
        <div className="pp-row">
          <span className="pp-label">Trang web:</span>
          <a
            className="pp-link"
            href={`https://${brand.website}`}
            target="_blank"
            rel="noreferrer"
          >
            {brand.website}
          </a>
        </div>
        <div className="pp-row">
          <span className="pp-label">Điện thoại:</span>
          <a
            className="pp-link"
            href={`tel:${brand.phone.replace(/[^\d+]/g, "")}`}
          >
            {brand.phone}
          </a>
        </div>
        <div className="pp-row">
          <span className="pp-label">Email:</span>
          <a className="pp-link" href={`mailto:${brand.email}`}>
            {brand.email}
          </a>
        </div>
        <div className="pp-row">
          <span className="pp-label">Cập nhật:</span>
          <span className="pp-value">{brand.updatedAt}</span>
        </div>
        <div className="">
          <span className="pp-label"></span>
          <a style={{ textDecoration: "none" }} href="/privacysiam">
            Chính sách bảo mật
          </a>
        </div>
      </div>
    </section>
  );
}
